import React from 'react';

import { Button, Link } from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';

const GoToSignUpButton: React.FC = () => {
  const { t } = useTranslation('pages.signIn.form');

  return (
    <Button variant="ghost" w="full" as={Link} href={routes.signUp.url}>
      {t('goToSignUp')}
    </Button>
  );
};

export default GoToSignUpButton;
